import CustomGallery from './CustomGallery';

export default function Landscape(props) {
    return(
        <CustomGallery genre='landscape' photos={props.photos} addPhotos={props.addPhotos}/>
    )
}